import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http } from "../lib/api";

export const UploadButton = ({ accept = "image/*", multiple = false, label = "Upload", testid, onUploaded }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    const urls = [];
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await http.post("/media/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const p = data.url || data.path;
        urls.push(p.startsWith("http") ? p : `${process.env.REACT_APP_BACKEND_URL}${p}`);
      } catch (err) {
        toast.error(`${file.name}: ${err.response?.data?.detail || "upload failed"}`);
      }
    }
    setBusy(false);
    e.target.value = "";
    if (urls.length) {
      toast.success(`${urls.length} file${urls.length > 1 ? "s" : ""} uploaded`);
      onUploaded(urls);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handle}
        className="hidden"
        data-testid={`${testid}-input`}
      />
      <button
        type="button"
        data-testid={testid}
        disabled={busy}
        onClick={() => inputRef.current?.click()}
        className="bg-[#061224] border border-[#FF5A00] hover:bg-[#FF5A00] disabled:opacity-50 transition-colors px-5 py-3 text-xs font-bold uppercase tracking-[0.15em] flex items-center gap-2 shrink-0"
      >
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
        {busy ? "Uploading…" : label}
      </button>
    </>
  );
};
